export enum WalletDepositType {
	Unknown,
	Expert,
	Support,
	Training,
	Software,
}
